import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { _ as _ts_values } from "@swc/helpers/_/_ts_values";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import { Stack, Tooltip } from "@mui/material";
import Select from "react-select";
import { Formik, useFormikContext } from "formik";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import moment from "moment";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { ModalAllder } from "layouts/ModalAllder";
import DataTableLayout from "layouts/DatatableLayout";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ButtonMui from "@mui/material/Button";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { allShop } from "../../redux/handlers/manage/allShop.handler";
import { getSaleuser } from "../../redux/handlers/manage/getSaleuser.handler";
import { getDataVisit } from "../../redux/handlers/manage/getDataVisit.handler";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { getObjective } from "../../redux/handlers/manage/getObjective.handler";
import { createVisit, clearcreateVisit } from "../../redux/handlers/manage/createVisit.handler";
import { updateVisit, clearupdateVisit } from "../../redux/handlers/manage/updateVisit.handler";
import { updateStatusVisit, clearupdateStatusVisit } from "../../redux/handlers/manage/updateStatusVisit.handler";
import { uploadVisit } from "../../redux/handlers/manage/uploadVisit.handler";
import { detailVisit } from "../../redux/handlers/manage/detailVisit.handler";
import { getInfoAdminSystem } from "utils/HelperFunction";
import { getShop } from "../../redux/handlers/manage/getShop.handler";
import { allSetUser } from "../../redux/handlers/manage/allSetUser.handler";
import { getDataVisitTotal } from "../../redux/handlers/manage/getDataVisitTotal.handler";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PersonIcon from "@mui/icons-material/Person";
function FocusFirstFormikError() {
    var _useFormikContext = useFormikContext(), errors = _useFormikContext.errors, isValidating = _useFormikContext.isValidating, submitCount = _useFormikContext.submitCount;
    var focusedSubmitCount = useRef(0);
    useEffect(function() {
        if (submitCount === 0 || isValidating || focusedSubmitCount.current === submitCount) {
            return;
        }
        var firstErrorField = Object.keys(errors)[0];
        if (!firstErrorField) return;
        focusedSubmitCount.current = submitCount;
        var focusTimer = window.setTimeout(function() {
            var field = document.querySelector('[name="'.concat(firstErrorField, '"]')) || document.querySelector('[data-formik-field="'.concat(firstErrorField, '"] input'));
            if (!field) return;
            var scrollTarget = field.closest("[data-formik-field]") || field.closest(".form-st-3") || field;
            scrollTarget.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
            window.setTimeout(function() {
                return field.focus({
                    preventScroll: true
                });
            }, 300);
        }, 0);
        return function() {
            return window.clearTimeout(focusTimer);
        };
    }, [
        errors,
        isValidating,
        submitCount
    ]);
    return null;
}
export function ShopVisitList() {
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), rowData = _useState[0], setRowData = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), filterText = _useState1[0], setFilterText = _useState1[1];
    var _useState2 = _sliced_to_array(useState(new Date(new Date().setDate(new Date().getDate() - 15))), 2), sDate = _useState2[0], setSDate = _useState2[1];
    var _useState3 = _sliced_to_array(useState(new Date()), 2), eDate = _useState3[0], setEDate = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), optionShop = _useState4[0], setOptionShop = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), filShop = _useState5[0], setFilShop = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), shopId = _useState6[0], setShopId = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), optionBranch = _useState7[0], setOptionBranch = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), filBranch = _useState8[0], setFilBranch = _useState8[1];
    var _useState9 = _sliced_to_array(useState(""), 2), branchId = _useState9[0], setBranchId = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), optionSale = _useState10[0], setOptionSale = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), filSale = _useState11[0], setFilSale = _useState11[1];
    var _useState12 = _sliced_to_array(useState(""), 2), saleId = _useState12[0], setSaleId = _useState12[1];
    var _useState13 = _sliced_to_array(useState([]), 2), optionSupport = _useState13[0], setOptionSupport = _useState13[1];
    var _useState14 = _sliced_to_array(useState([]), 2), filSupport = _useState14[0], setFilSupport = _useState14[1];
    var _useState15 = _sliced_to_array(useState(""), 2), supportId = _useState15[0], setSupportId = _useState15[1];
    var _useState16 = _sliced_to_array(useState({}), 2), visitTotal = _useState16[0], setVisitTotal = _useState16[1];
    var _useState17 = _sliced_to_array(useState(""), 2), modelText = _useState17[0], setmodelText = _useState17[1];
    var _useState18 = _sliced_to_array(useState(false), 2), modalsuccess = _useState18[0], setModalsuccess = _useState18[1];
    var _useState19 = _sliced_to_array(useState(false), 2), textsuccess = _useState19[0], setTextsuccess = _useState19[1];
    var _useState20 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: !isMobile ? 500 : 300,
        height: !isMobile ? 350 : 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalStatus = _useState20[0], setModalStatus = _useState20[1];
    var getDataVisitReducer = useAppSelector(function(state) {
        return state.getDataVisitReducer;
    });
    var getShopReducer = useAppSelector(function(state) {
        return state.getShopReducer;
    });
    var allSetUserReducer = useAppSelector(function(state) {
        return state.allSetUserReducer;
    });
    var getDataVisitTotalReducer = useAppSelector(function(state) {
        return state.getDataVisitTotalReducer;
    });
    var visitFilterPayload = useMemo(function() {
        return {
            visitshid: parseInt(shopId),
            visitshbranchid: parseInt(branchId),
            visitsaleid: parseInt(saleId),
            searchtext: filterText,
            sDate: sDate ? moment(sDate).format("YYYY-MM-DD") : "",
            eDate: eDate ? moment(eDate).format("YYYY-MM-DD") : "",
            visitsupportid: parseInt(supportId)
        };
    }, [
        shopId,
        branchId,
        saleId,
        filterText,
        sDate,
        eDate,
        supportId
    ]);
    useEffect(function() {
        dispatch(getShop({}, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(allSetUser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        dispatch(getDataVisit(visitFilterPayload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getDataVisitTotal(visitFilterPayload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        visitFilterPayload
    ]);
    useEffect(function() {
        setIsLoading(getDataVisitReducer.isFetching || getShopReducer.isFetching || allSetUserReducer.isFetching);
        if (getShopReducer.data) {
            var filteredData = adminInfo.userRoleId != 3 ? getShopReducer.data.data : getShopReducer.data.data.filter(function(ele) {
                return ele.sh_branch_intendant === adminInfo.userId;
            });
            // เช็คร้านค้า กันชื่อซ้ำ
            var seen = new Set();
            var uniqueData = filteredData.filter(function(ele) {
                var _ele_shShop;
                var name = (_ele_shShop = ele.shShop) === null || _ele_shShop === void 0 ? void 0 : _ele_shShop.sh_shop_name;
                if (name && !seen.has(name)) {
                    seen.add(name);
                    return true;
                }
                return false;
            }).map(function(ele) {
                var _ele_shShop;
                return {
                    value: ele.sh_branch_shid,
                    label: (_ele_shShop = ele.shShop) === null || _ele_shShop === void 0 ? void 0 : _ele_shShop.sh_shop_name
                };
            });
            setFilShop(uniqueData);
            // เช็คสาขา กันชื่อซ้ำ
            var bran = new Set();
            var uniqueBran = filteredData.filter(function(ele) {
                var name = ele.sh_branch_name;
                if (name && !bran.has(name)) {
                    bran.add(name);
                    return true;
                }
                return false;
            }).map(function(ele) {
                var _ele_shShop;
                return {
                    value: ele === null || ele === void 0 ? void 0 : ele.sh_branch_id,
                    label: "".concat(ele === null || ele === void 0 ? void 0 : ele.sh_branch_name, " ( ").concat((_ele_shShop = ele.shShop) === null || _ele_shShop === void 0 ? void 0 : _ele_shShop.sh_shop_name, " )")
                };
            });
            setFilBranch(uniqueBran);
        }
        if (allSetUserReducer.data) {
            var op = allSetUserReducer.data.data;
            var arrSupport = [];
            var arrSale = [];
            op.filter(function(v) {
                return v.sys_user_role_id === 5;
            }).map(function(ele) {
                return arrSupport.push({
                    value: ele.sys_user_id,
                    label: "".concat(ele.sys_user_fullname, " ( ").concat(ele.sys_user_nname, " ) ")
                });
            });
            setFilSupport(arrSupport);
            op.filter(function(v) {
                return v.sys_user_role_id === 3;
            }).map(function(ele) {
                return arrSale.push({
                    value: ele.sys_user_id,
                    label: "".concat(ele.sys_user_fullname, " ( ").concat(ele.sys_user_nname, " ) ")
                });
            });
            setFilSale(arrSale);
        }
        if (getDataVisitReducer.data) {
            var data = adminInfo.userRoleId === 3 && getDataVisitReducer.data.data.filter(function(v) {
                return v.vs_visit_saleid == adminInfo.userId;
            }) || adminInfo.userRoleId === 5 && getDataVisitReducer.data.data.filter(function(v) {
                return v.vs_visit_supportid == adminInfo.userId;
            }) || getDataVisitReducer.data.data;
            setRowData(data);
            // เช็ด ร้านที่ที่มี data ในนี้
            var shids = data.map(function(d) {
                return d.vs_visit_shid;
            }).filter(function(v) {
                return !!v;
            });
            var all = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            if (shids.length === 0) {
                setOptionShop([]);
                return;
            }
            var arrsh = filShop.filter(function(shop) {
                return shids.includes(shop.value);
            });
            setOptionShop(_to_consumable_array(all).concat(_to_consumable_array(arrsh)));
            // เช็ด สาขาที่ที่มี data ในนี้
            var brids = data.map(function(d) {
                return d.vs_visit_shbranchid;
            }).filter(function(v) {
                return !!v;
            });
            if (brids.length === 0) {
                setOptionBranch([]);
                return;
            }
            var arrbr = filBranch.filter(function(br) {
                return brids.includes(br.value);
            });
            setOptionBranch(_to_consumable_array(all).concat(_to_consumable_array(arrbr)));
            // เช็ด เซลล์ที่ที่มี data ในนี้
            var sales = data.map(function(d) {
                return d.vs_visit_saleid;
            }).filter(function(v) {
                return !!v;
            });
            if (sales.length === 0) {
                setOptionSale([]);
                return;
            }
            var arrsale = filSale.filter(function(s) {
                return sales.includes(s.value);
            });
            setOptionSale(_to_consumable_array(all).concat(_to_consumable_array(arrsale)));
            // เช็ด ซัพพอร์ตที่ที่มี data ในนี้
            var supp = data.map(function(d) {
                return d.vs_visit_supportid;
            }).filter(function(v) {
                return !!v;
            });
            if (supp.length === 0) {
                setOptionSupport([]);
                return;
            }
            var arrsupp = filSupport.filter(function(s) {
                return supp.includes(s.value);
            });
            setOptionSupport(_to_consumable_array(all).concat(_to_consumable_array(arrsupp)));
        }
    }, [
        getDataVisitReducer,
        getShopReducer,
        allSetUserReducer
    ]);
    useEffect(function() {
        setIsLoading(getDataVisitTotalReducer.isFetching);
        if (getDataVisitTotalReducer.data) {
            var _getDataVisitTotalReducer_data;
            setVisitTotal(getDataVisitTotalReducer === null || getDataVisitTotalReducer === void 0 ? void 0 : (_getDataVisitTotalReducer_data = getDataVisitTotalReducer.data) === null || _getDataVisitTotalReducer_data === void 0 ? void 0 : _getDataVisitTotalReducer_data.data);
        }
    }, [
        getDataVisitTotalReducer
    ]);
    var visitColumns = [
        {
            name: "รหัสใบเยี่ยมชม",
            selector: function(row) {
                return row.vs_visit_code;
            },
            center: "true",
            width: "150px"
        },
        {
            name: "วัน-เวลา ที่นัดหมาย",
            selector: function(row) {
                return row.vs_visit_appointmentdate ? moment.parseZone(row.vs_visit_appointmentdate).format("DD/MM/YYYY HH:mm") : "-";
            },
            center: "true",
            width: "170px"
        },
        {
            name: "วัน-เวลา ที่เข้าพบ",
            selector: function(row) {
                return row.vs_visit_visitdate ? moment.parseZone(row.vs_visit_visitdate).format("DD/MM/YYYY HH:mm") : "-";
            },
            center: "true",
            width: "170px"
        },
        {
            name: "ชื่อร้าน-สาขา",
            selector: function(row) {
                return row.vs_visit_shopname;
            },
            // center: "true",
            width: "200px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs(Stack, {
                    direction: "column",
                    justifyContent: "flex-start",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: row.vs_visit_shopname
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: "(".concat(row.vs_visit_branchname, ")")
                        })
                    ]
                });
            }
        },
        {
            name: "เซลล์ผู้ดูแล",
            selector: function(row) {
                return row.vs_visit_salename || "-";
            },
            // center: "true",
            width: "180px"
        },
        {
            name: "เซลล์ซัพพอร์ต",
            selector: function(row) {
                return row.vs_visit_supportid;
            },
            // center: "true",
            width: "180px",
            cell: function(row, index, column, id) {
                return row.vs_visit_supportid ? row.SupportUser.sys_user_fullname : "-";
            }
        },
        {
            name: "วัตถุประสงค์",
            selector: function(row) {
                return row.VsObjective && row.VsObjective.length > 0 ? row.VsObjective.map(function(obj) {
                    return obj.vs_objective_name;
                }).join(" , ") : "-";
            },
            // center: "true",
            width: "300px"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.vs_visit_status;
            },
            center: "true",
            width: "170px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(Tooltip, {
                    title: "เปลี่ยนสถานะใบเยี่ยมชมร้านค้า",
                    children: /*#__PURE__*/ _jsx(ButtonMui, {
                        variant: "contained",
                        endIcon: /*#__PURE__*/ _jsx(ArrowDropDownIcon, {}),
                        className: "px-2 py-1 text-center",
                        disabled: row.vs_visit_status == 3 ? true : false,
                        onClick: function() {
                            setmodelText("สถานะใบเยี่ยมชมร้านค้า");
                            setModalStatus(function(prev) {
                                return _object_spread_props(_object_spread({}, prev), {
                                    open: true,
                                    typeData: "visitStatus",
                                    data: {
                                        id: row.vs_visit_id,
                                        name: row.vs_visit_status_text == "เยี่ยมชม" ? "เยี่ยมชมแล้ว" : row.vs_visit_status_text,
                                        status: row.vs_visit_status,
                                        text: row.vs_visit_cancelremark
                                    }
                                });
                            });
                        },
                        style: {
                            color: row.vs_visit_status == 4 && "rgba(224, 13, 235, 1)" || row.vs_visit_status == 3 && "rgba(211, 47, 47, 1)" || row.vs_visit_status == 2 && "rgba(255, 255, 255, 1)" || row.vs_visit_status == 1 && "rgba(253, 180, 40, 1)",
                            backgroundColor: row.vs_visit_status == 4 && "rgba(248, 193, 249, 1)" || row.vs_visit_status == 3 && "rgba(253, 237, 237, 1)" || row.vs_visit_status == 2 && "rgba(16, 176, 42, 1)" || row.vs_visit_status == 1 && "rgba(255, 246, 229, 1)",
                            borderRadius: "20px",
                            width: "130px"
                        },
                        children: row.vs_visit_status_text == "เยี่ยมชม" ? "เยี่ยมชมแล้ว" : row.vs_visit_status_text
                    })
                });
            }
        },
        {
            name: "วันที่ทำรายการ",
            selector: function(row) {
                return row.vs_visit_credate ? moment.parseZone(row.vs_visit_credate).format("DD/MM/YYYY HH:mm") : "-";
            },
            center: "true",
            width: "190px"
        },
        {
            name: "หมายเหตุการยกเลิก",
            selector: function(row) {
                return row.vs_visit_cancelremark ? row.vs_visit_cancelremark : "-";
            },
            // center: "true",
            width: "180px"
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.vs_visit_id;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            style: {
                                marginRight: 5
                            },
                            to: "/shopvisit/manage/".concat(row.vs_visit_id),
                            children: /*#__PURE__*/ _jsx(Tooltip, {
                                title: "แก้ไขใบเยี่ยมชมร้านค้า",
                                children: /*#__PURE__*/ _jsx(EditIcon, {
                                    style: {
                                        color: "#797A7A",
                                        fontSize: 30,
                                        borderRadius: 40,
                                        background: "#E9E9E9",
                                        padding: 5
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            style: {
                                marginRight: 5
                            },
                            to: "/shopvisit/manage/".concat(row.vs_visit_id, "/view"),
                            children: /*#__PURE__*/ _jsx(Tooltip, {
                                title: "รายละเอียด",
                                children: /*#__PURE__*/ _jsx(VisibilityIcon, {
                                    style: {
                                        fontSize: 30,
                                        borderRadius: 40,
                                        background: "#FFF1DD",
                                        color: "#FFA319",
                                        padding: 5
                                    }
                                })
                            })
                        })
                    ]
                });
            }
        }
    ];
    var pinnedColumnNames = [
        "จัดการ",
        "สถานะ"
    ];
    var columns = _to_consumable_array(pinnedColumnNames.map(function(name) {
        return visitColumns.find(function(column) {
            return column.name === name;
        });
    })).concat(_to_consumable_array(visitColumns.filter(function(column) {
        return !pinnedColumnNames.includes(column.name);
    })));
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: !isMobile ? "pagezoom" : "px-2",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/shopvisit",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการใบเยี่ยมชมร้านค้า"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: !isMobile ? "fs-24 mb-2" : "fs-20 mb-2",
                        children: "ใบเยี่ยมชมร้านค้า"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "row gx-xl-4",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-xl-3 col-md-12",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-4 !bg-[#11b12a] !text-[#FFF]",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: !isMobile ? "fs-24 mb-2" : "fs-20 mb-2",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "me-2",
                                                        children: /*#__PURE__*/ _jsx(ListAltIcon, {})
                                                    }),
                                                    "จำนวนใบเยี่ยม"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-20 mb-2 text-right",
                                                children: (visitTotal === null || visitTotal === void 0 ? void 0 : visitTotal.total_visit) || 0
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-xl-3 col-md-12",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-4 !bg-[#fff7e5] !text-[#fdb429]",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: !isMobile ? "fs-24 mb-2" : "fs-20 mb-2",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "me-2",
                                                        children: /*#__PURE__*/ _jsx(PersonIcon, {})
                                                    }),
                                                    "จำนวนเซลล์ไปเยี่ยมชม"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-20 mb-2 text-right",
                                                children: (visitTotal === null || visitTotal === void 0 ? void 0 : visitTotal.total_sale) || 0
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-xl-3 col-md-12",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-4 !bg-[#f0803e] !text-[#FFF]",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: !isMobile ? "fs-24 mb-2" : "fs-20 mb-2",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "me-2",
                                                        children: /*#__PURE__*/ _jsx(PersonIcon, {})
                                                    }),
                                                    "จำนวนร้านค้าที่ไปเยี่ยมชม"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-20 mb-2 text-right",
                                                children: (visitTotal === null || visitTotal === void 0 ? void 0 : visitTotal.total_shop) || 0
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3 mb-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body",
                        children: !isMobile ? /*#__PURE__*/ _jsxs("div", {
                            className: "pt-3 px-0",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "row gx-xl-4",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-xl-7 col-md-12",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3 col-md-12",
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            className: "mb-2",
                                                            children: "ค้นหาตามช่วงวันที่นัดหมาย"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-4 col-md-12",
                                                        children: /*#__PURE__*/ _jsx(DatePicker, {
                                                            selected: sDate,
                                                            onChange: function(date) {
                                                                return setSDate(date);
                                                            },
                                                            dateFormat: "dd-MM-yyyy",
                                                            className: "form-control px-2 mb-2"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-1 col-md-12",
                                                        children: /*#__PURE__*/ _jsx("center", {
                                                            className: "mb-2",
                                                            children: "ถึง"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-4 col-md-12",
                                                        children: /*#__PURE__*/ _jsx(DatePicker, {
                                                            selected: eDate,
                                                            onChange: function(date) {
                                                                return setEDate(date);
                                                            },
                                                            dateFormat: "dd-MM-yyyy",
                                                            className: "form-control px-2 mb-2"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-xl-5 col-md-12",
                                            children: /*#__PURE__*/ _jsx(Form.Group, {
                                                className: "mb-2",
                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                    direction: "horizontal",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            className: "form-control py-0 me-3",
                                                            placeholder: "ค้นหารายการ",
                                                            onKeyUp: function(e) {
                                                                return setFilterText(e.target.value);
                                                            }
                                                        }),
                                                        /*#__PURE__*/ _jsx(Link, {
                                                            className: "btn btn-dg w-[200px]",
                                                            to: "/shopvisit/manage",
                                                            children: "สร้างใบเยี่ยมชม"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "row gx-xl-4",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-xl-3 col-md-6",
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "mb-2 form-st-3 p-0",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1",
                                                        children: "ค้นหาร้านค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Select, {
                                                        as: "select",
                                                        className: "w-100 select-st-3",
                                                        placeholder: "ค้นหาร้านค้า",
                                                        options: optionShop,
                                                        defaultValue: 0,
                                                        value: optionShop.find(function(opt) {
                                                            return opt.value === shopId;
                                                        }) || "",
                                                        menuPortalTarget: document.body,
                                                        menuPosition: "fixed",
                                                        styles: {
                                                            menuPortal: function(base) {
                                                                return _object_spread_props(_object_spread({}, base), {
                                                                    zIndex: 9999
                                                                });
                                                            },
                                                            menu: function(base) {
                                                                return _object_spread_props(_object_spread({}, base), {
                                                                    zIndex: 9999
                                                                });
                                                            }
                                                        },
                                                        onChange: function(e) {
                                                            setShopId(e ? e.value : "");
                                                        },
                                                        isClearable: true
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-xl-3 col-md-6",
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "mb-2 form-st-3",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1",
                                                        children: "ค้นหาสาขา"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Select, {
                                                        as: "select",
                                                        className: "w-100 select-st-3",
                                                        placeholder: "ค้นหาสาขา",
                                                        options: optionBranch,
                                                        value: optionBranch.find(function(opt) {
                                                            return opt.value === branchId;
                                                        }) || "",
                                                        onChange: function(e) {
                                                            setBranchId(e ? e.value : "");
                                                        },
                                                        isClearable: true
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-xl-3 col-md-6",
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "mb-2 form-st-3",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1",
                                                        children: "ค้นหาเซลล์ที่ดูแล"
                                                    }),
                                                    adminInfo.userRoleId != 3 ? /*#__PURE__*/ _jsx(Select, {
                                                        as: "select",
                                                        className: "w-100 select-st-3",
                                                        placeholder: "ค้นหาเซลล์ที่ดูแล",
                                                        options: optionSale,
                                                        value: optionSale.find(function(opt) {
                                                            return opt.value === saleId;
                                                        }) || "",
                                                        onChange: function(e) {
                                                            setSaleId(e ? e.value : "");
                                                        },
                                                        isClearable: true
                                                    }) : /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        className: "form-st-3 py-2",
                                                        placeholder: "ค้นหาเซลล์ที่ดูแล",
                                                        value: adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userFullName,
                                                        disabled: true
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-xl-3 col-md-6",
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "mb-2 form-st-3",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1",
                                                        children: "ค้นหาเซลล์ซัพพอร์ต"
                                                    }),
                                                    adminInfo.userRoleId != 5 ? /*#__PURE__*/ _jsx(Select, {
                                                        as: "select",
                                                        className: "w-100 select-st-3",
                                                        placeholder: "ค้นหาเซลล์ซัพพอร์ต",
                                                        options: optionSupport,
                                                        value: optionSupport.find(function(opt) {
                                                            return opt.value === supportId;
                                                        }) || "",
                                                        onChange: function(e) {
                                                            setSupportId(e ? e.value : "");
                                                        },
                                                        isClearable: true
                                                    }) : /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        className: "form-st-3 py-2",
                                                        placeholder: "ค้นหาเซลล์ซัพพอร์ต",
                                                        value: adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userFullName,
                                                        disabled: true
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx("div", {
                            className: "pt-1 px-0",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-12",
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "mb-2",
                                            children: "ค้นหาตามช่วงวันที่นัดหมาย"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-12",
                                        children: /*#__PURE__*/ _jsx(DatePicker, {
                                            selected: sDate,
                                            onChange: function(date) {
                                                return setSDate(date);
                                            },
                                            dateFormat: "dd-MM-yyyy",
                                            className: "form-control px-2 mb-2"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-12",
                                        children: /*#__PURE__*/ _jsx("center", {
                                            className: "mb-2",
                                            children: "ถึง"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-12",
                                        children: /*#__PURE__*/ _jsx(DatePicker, {
                                            selected: eDate,
                                            onChange: function(date) {
                                                return setEDate(date);
                                            },
                                            dateFormat: "dd-MM-yyyy",
                                            className: "form-control px-2 mb-2"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-12",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 p-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ค้นหาร้านค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    as: "select",
                                                    className: "w-100 select-st-3",
                                                    placeholder: "ค้นหาร้านค้า",
                                                    options: optionShop,
                                                    defaultValue: 0,
                                                    value: optionShop.find(function(opt) {
                                                        return opt.value === shopId;
                                                    }) || "",
                                                    menuPortalTarget: document.body,
                                                    menuPosition: "fixed",
                                                    styles: {
                                                        menuPortal: function(base) {
                                                            return _object_spread_props(_object_spread({}, base), {
                                                                zIndex: 9999
                                                            });
                                                        },
                                                        menu: function(base) {
                                                            return _object_spread_props(_object_spread({}, base), {
                                                                zIndex: 9999
                                                            });
                                                        }
                                                    },
                                                    onChange: function(e) {
                                                        setShopId(e ? e.value : "");
                                                    },
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-12",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ค้นหาสาขา"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    as: "select",
                                                    className: "w-100 select-st-3",
                                                    placeholder: "ค้นหาสาขา",
                                                    options: optionBranch,
                                                    value: optionBranch.find(function(opt) {
                                                        return opt.value === branchId;
                                                    }) || "",
                                                    onChange: function(e) {
                                                        setBranchId(e ? e.value : "");
                                                    },
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-12",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-3 form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ค้นหาเซลล์ที่ดูแล"
                                                }),
                                                adminInfo.userRoleId != 3 ? /*#__PURE__*/ _jsx(Select, {
                                                    as: "select",
                                                    className: "w-100 select-st-3",
                                                    placeholder: "ค้นหาเซลล์ที่ดูแล",
                                                    options: optionSale,
                                                    value: optionSale.find(function(opt) {
                                                        return opt.value === saleId;
                                                    }) || "",
                                                    onChange: function(e) {
                                                        setSaleId(e ? e.value : "");
                                                    },
                                                    isClearable: true
                                                }) : /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    className: "form-st-3 py-2",
                                                    placeholder: "ค้นหาเซลล์ที่ดูแล",
                                                    value: adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userFullName,
                                                    disabled: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-12",
                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                            type: "text",
                                            className: "form-control mb-3",
                                            placeholder: "ค้นหารายการ",
                                            onKeyUp: function(e) {
                                                return setFilterText(e.target.value);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-12",
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            className: "btn btn-dg w-[100%]",
                                            to: "/shopvisit/manage",
                                            children: "สร้างใบเยี่ยมชม"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "card-body pt-0 px-0",
                        style: {
                            overflowX: "auto"
                        },
                        children: [
                            /*#__PURE__*/ _jsx("style", {
                                children: "\n            .shop-visit-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n            .shop-visit-pinned-table .rdt_TableRow .rdt_TableCell:nth-child(1) {\n              position: sticky !important;\n              left: 0 !important;\n              z-index: 3 !important;\n              background-color: #ffffff !important;\n              box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08) !important;\n            }\n\n            .shop-visit-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n            .shop-visit-pinned-table .rdt_TableRow .rdt_TableCell:nth-child(2) {\n              position: sticky !important;\n              left: 150px !important;\n              z-index: 3 !important;\n              background-color: #ffffff !important;\n              box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08) !important;\n            }\n\n            .shop-visit-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n            .shop-visit-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(2) {\n              z-index: 4 !important;\n              background-color: #F5F5F7 !important;\n            }\n\n            @media (max-width: 991.98px) {\n              .shop-visit-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n              .shop-visit-pinned-table .rdt_TableRow .rdt_TableCell:nth-child(1),\n              .shop-visit-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n              .shop-visit-pinned-table .rdt_TableRow .rdt_TableCell:nth-child(2) {\n                position: static !important;\n                left: auto !important;\n                z-index: auto !important;\n                box-shadow: none !important;\n              }\n\n              .shop-visit-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n              .shop-visit-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(2) {\n                background-color: #F5F5F7 !important;\n              }\n            }\n          "
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "shop-visit-pinned-table",
                                children: /*#__PURE__*/ _jsx(DataTableLayout, {
                                    item: rowData,
                                    columns: columns,
                                    isSelectRows: false,
                                    PerPage: 10
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalStatus,
                setModal: setModalStatus,
                htitle: "สถานะใบเยี่ยมชมร้านค้า",
                hbtn: false,
                children: /*#__PURE__*/ _jsx(StatusModal, {
                    setModal: setModalStatus,
                    modal: modalStatus,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    isMobile: isMobile,
                    filterPayload: visitFilterPayload
                })
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
export function ShopVisitManage() {
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var param = useParams();
    var dataID = useMemo(function() {
        return param.dataID ? param.dataID : null;
    }, [
        param.dataID
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), modalsuccess = _useState[0], setModalsuccess = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), textsuccess = _useState1[0], setTextsuccess = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        branchid: null,
        branch_shid: null
    }), 2), formdata = _useState2[0], setFormdata = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), autoShop = _useState3[0], setAutoShop = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), optionSale = _useState4[0], setOptionSale = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), dataObjective = _useState5[0], setDataObjective = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), selectedObjectives = _useState6[0], setSelectedObjectives = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), visitDate = _useState7[0], setVisitDate = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), visitDateErr = _useState8[0], setVisitDateErr = _useState8[1];
    var _useState9 = _sliced_to_array(useState(""), 2), appDate = _useState9[0], setAppDate = _useState9[1];
    var _useState10 = _sliced_to_array(useState(null), 2), originalAppDate = _useState10[0], setOriginalAppDate = _useState10[1];
    var _useState11 = _sliced_to_array(useState(null), 2), originalVisitDate = _useState11[0], setOriginalVisitDate = _useState11[1];
    var _useState12 = _sliced_to_array(useState([]), 2), galleryPath = _useState12[0], setGalleryPath = _useState12[1];
    var _useState13 = _sliced_to_array(useState([]), 2), galleryDel = _useState13[0], setGalleryDel = _useState13[1];
    var _useState14 = _sliced_to_array(useState([]), 2), originalObjectives = _useState14[0], setOriginalObjectives = _useState14[1];
    var _useState15 = _sliced_to_array(useState(1), 2), status = _useState15[0], setStatus = _useState15[1];
    var _useState16 = _sliced_to_array(useState([]), 2), salesSupport = _useState16[0], setSalesSupport = _useState16[1];
    var appointmentBoundaryDate = useMemo(function() {
        if (dataID && originalAppDate) {
            return originalAppDate;
        }
        var now = new Date();
        now.setHours(now.getHours() - 2);
        now.setSeconds(0, 0);
        return now;
    }, [
        dataID,
        originalAppDate
    ]);
    var canSelectAppointmentTime = function(time) {
        if (!appointmentBoundaryDate) {
            return true;
        }
        var baseDate = appDate || appointmentBoundaryDate;
        var compareDate = new Date(baseDate);
        compareDate.setHours(time.getHours(), time.getMinutes(), 0, 0);
        var isSameDay = compareDate.getFullYear() === appointmentBoundaryDate.getFullYear() && compareDate.getMonth() === appointmentBoundaryDate.getMonth() && compareDate.getDate() === appointmentBoundaryDate.getDate();
        if (!isSameDay) {
            return true;
        }
        return compareDate.getTime() >= appointmentBoundaryDate.getTime();
    };
    var visitBoundaryDate = useMemo(function() {
        var twoHoursAgo = new Date();
        twoHoursAgo.setHours(twoHoursAgo.getHours() - 2);
        twoHoursAgo.setSeconds(0, 0);
        var earliestVisitDate = originalVisitDate || twoHoursAgo;
        return appDate && appDate.getTime() > earliestVisitDate.getTime() ? appDate : earliestVisitDate;
    }, [
        appDate,
        originalVisitDate
    ]);
    var canSelectVisitTime = function(time) {
        if (!visitBoundaryDate) {
            return true;
        }
        var baseDate = visitDate || visitBoundaryDate;
        var compareDate = new Date(baseDate);
        compareDate.setHours(time.getHours(), time.getMinutes(), 0, 0);
        var isSameDay = compareDate.getFullYear() === visitBoundaryDate.getFullYear() && compareDate.getMonth() === visitBoundaryDate.getMonth() && compareDate.getDate() === visitBoundaryDate.getDate();
        return !isSameDay || compareDate.getTime() >= visitBoundaryDate.getTime();
    };
    var _useState17 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 320,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalAlert = _useState17[0], setModalAlert = _useState17[1];
    var formatResult = function(item) {
        return /*#__PURE__*/ _jsx("div", {
            className: "fs-12",
            children: /*#__PURE__*/ _jsxs("div", {
                children: [
                    item.nameShop,
                    " ( ",
                    item.sh_branch_name,
                    " )"
                ]
            })
        }, item.sh_branch_id);
    };
    var allShopReducer = useAppSelector(function(state) {
        return state.allShopReducer;
    });
    var getObjectiveReducer = useAppSelector(function(state) {
        return state.getObjectiveReducer;
    });
    var createVisitReducer = useAppSelector(function(state) {
        return state.createVisitReducer;
    });
    var updateVisitReducer = useAppSelector(function(state) {
        return state.updateVisitReducer;
    });
    var getSaleuserReducer = useAppSelector(function(state) {
        return state.getSaleuserReducer;
    });
    var detailVisitReducer = useAppSelector(function(state) {
        return state.detailVisitReducer;
    });
    var allSetUserReducer = useAppSelector(function(state) {
        return state.allSetUserReducer;
    });
    useEffect(function() {
        dispatch(allShop({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getObjective({}, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getSaleuser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(allSetUser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        if (dataID) {
            dispatch(detailVisit({
                visitid: parseInt(dataID)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, []);
    // useEffect(() => {
    //   console.log("visitDate", visitDate);
    //   if (visitDate != '' &&  galleryPath.length > 0) {
    //     setVisitDateErr("กรุณาเพิ่มรูปภาพ");
    //   }else{
    //     setVisitDateErr("");
    //   }
    // }, [visitDate,galleryPath]);
    var objectiveDelete = originalObjectives.filter(function(orig) {
        return !selectedObjectives.some(function(sel) {
            return sel.vs_objective_objid === orig.vs_objective_objid;
        });
    }).map(function(obj) {
        return {
            vs_objective_id: obj.vs_objective_id
        };
    });
    useEffect(function() {
        setIsLoading(allShopReducer.isFetching || getObjectiveReducer.isFetching || getSaleuserReducer.isFetching || detailVisitReducer.isFetching || allSetUserReducer.isFetching);
        if (allShopReducer.data) {
            var arr = [];
            if (adminInfo.userRoleId != 3) {
                allShopReducer.data.data.map(function(ele) {
                    return ele.shBranch.map(function(item) {
                        return item.sh_branch_deleted == 2 && arr.push(_object_spread({
                            nameShop: ele.sh_shop_name
                        }, item));
                    });
                });
            } else {
                allShopReducer.data.data.map(function(ele) {
                    return ele.shBranch.filter(function(v) {
                        return v.sh_branch_intendant == adminInfo.userId;
                    }).map(function(item) {
                        return item.sh_branch_deleted == 2 && arr.push(_object_spread({
                            nameShop: ele.sh_shop_name
                        }, item));
                    });
                });
            }
            setAutoShop(arr);
        }
        if (getObjectiveReducer.data) {
            setDataObjective(getObjectiveReducer.data.data);
        }
        if (getSaleuserReducer.data) {
            var arr1 = [];
            getSaleuserReducer.data.data.map(function(ele) {
                return arr1.push({
                    value: ele.sys_user_id,
                    label: ele.sys_user_fullname
                });
            });
            setOptionSale(arr1);
        }
        if (dataID) {
            if (detailVisitReducer.data) {
                var data = detailVisitReducer.data.data[0];
                var aData = {
                    branchid: data.vs_visit_shbranchid,
                    branch_shid: data.vs_visit_shid,
                    vs_visit_shopname: data.vs_visit_shopname,
                    branch_name: data.vs_visit_branchname,
                    sh_branch_contactname: data.vs_visit_contactname,
                    sh_branch_contactphone: data.vs_visit_contactphone,
                    sh_branch_suptactname: data.vs_visit_suptactname,
                    sh_branch_suptactphone: data.vs_visit_suptactphone,
                    vs_visit_saleid: data.vs_visit_saleid,
                    // vs_visit_appointmentdate: data.vs_visit_appointmentdate
                    //   ? moment.utc(data.vs_visit_appointmentdate).toDate()
                    //   : "",
                    // vs_visit_visitdate: data.vs_visit_visitdate
                    //   ? moment.utc(data.vs_visit_visitdate).toDate()
                    //   : "",
                    vs_visit_results: data.vs_visit_results,
                    vs_visit_todonext: data.vs_visit_todonext,
                    vs_visit_cancelremark: data.vs_visit_cancelremark,
                    vs_visit_status: data.vs_visit_status,
                    vs_visit_id: data.vs_visit_id,
                    vs_visit_supportid: data.vs_visit_supportid ? data.vs_visit_supportid : null
                };
                setVisitDate("");
                setOriginalVisitDate(null);
                if (data.vs_visit_visitdate != null && data.vs_visit_visitdate != "" && data.vs_visit_visitdate != undefined) {
                    var utcDatevisitdate = new Date(data.vs_visit_visitdate);
                    if (utcDatevisitdate.toString() !== "Invalid Date") {
                        var localDatevisitdate = new Date(utcDatevisitdate.getTime() + utcDatevisitdate.getTimezoneOffset() * 60000);
                        setVisitDate(localDatevisitdate);
                        setOriginalVisitDate(localDatevisitdate);
                        aData = _object_spread_props(_object_spread({}, aData), {
                            vs_visit_visitdate: localDatevisitdate
                        });
                    }
                }
                // setVisitDate(
                //   data.vs_visit_visitdate ? moment.utc(data.vs_visit_visitdate).toDate() : ""
                // );
                setAppDate("");
                setOriginalAppDate(null);
                if (data.vs_visit_appointmentdate != null && data.vs_visit_appointmentdate != "" && data.vs_visit_appointmentdate != undefined) {
                    var utcDateappointmentdate = new Date(data.vs_visit_appointmentdate);
                    if (utcDateappointmentdate.toString() !== "Invalid Date") {
                        var localDateappointmentdate = new Date(utcDateappointmentdate.getTime() + utcDateappointmentdate.getTimezoneOffset() * 60000);
                        setAppDate(localDateappointmentdate);
                        setOriginalAppDate(localDateappointmentdate);
                        aData = _object_spread_props(_object_spread({}, aData), {
                            vs_visit_appointmentdate: localDateappointmentdate
                        });
                    }
                }
                // setAppDate(
                //   data.vs_visit_appointmentdate
                //     ? moment.utc(data.vs_visit_appointmentdate).toDate()
                //     : ""
                // );
                setFormdata(aData);
                if (data.VsObjective) {
                    setSelectedObjectives(data.VsObjective.map(function(obj) {
                        return {
                            vs_objective_objid: obj.vs_objective_objid,
                            vs_objective_name: obj.vs_objective_name
                        };
                    }));
                }
                setOriginalObjectives(data.VsObjective);
                if (data.VsFile) {
                    setGalleryPath(data.VsFile.map(function(obj) {
                        return {
                            id: nanoid(),
                            vs_file_id: obj.vs_file_id,
                            vs_file_visitid: obj.vs_file_visitid,
                            vs_file_url: obj.vs_file_url,
                            vs_file_name: obj.vs_file_name,
                            type: "update"
                        };
                    }));
                }
            }
        }
        if (allSetUserReducer.data) {
            var op = allSetUserReducer.data.data;
            var arr2 = [];
            op.filter(function(v) {
                return v.sys_user_role_id === 5;
            }).map(function(ele) {
                return arr2.push({
                    value: ele.sys_user_id,
                    label: ele.sys_user_fullname
                });
            });
            setSalesSupport(arr2);
        }
    }, [
        allShopReducer,
        getObjectiveReducer,
        getSaleuserReducer,
        detailVisitReducer,
        allSetUserReducer
    ]);
    useEffect(function() {
        setIsLoading(createVisitReducer.isFetching || updateVisitReducer.isFetching);
        if (createVisitReducer.data && !createVisitReducer.isError) {
            setTextsuccess("สร้างใบเยี่ยมชมร้านค้าสำเร็จ");
            dispatch(clearcreateVisit());
            setModalsuccess(true);
        // navigate("/shopvisit");
        }
        if (updateVisitReducer.data && !updateVisitReducer.isError) {
            setTextsuccess("แก้ไขใบเยี่ยมชมร้านค้าสำเร็จ");
            dispatch(clearupdateVisit());
            setModalsuccess(true);
        // navigate("/shopvisit");
        }
    }, [
        createVisitReducer,
        updateVisitReducer
    ]);
    var handlePreviewimage = function() {
        var _ref = _async_to_generator(function(e) {
            var files, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(e.target.files.length > 0)) return [
                            3,
                            8
                        ];
                        files = Array.from(e.target.files);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _loop = function() {
                            var file, formData, res;
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        file = _step.value;
                                        formData = new FormData();
                                        formData.append("upload_visit", file);
                                        return [
                                            4,
                                            dispatch(uploadVisit(formData, {
                                                modalObj: modalObj,
                                                setModalObj: setModalObj
                                            }))
                                        ];
                                    case 1:
                                        res = _state.sent();
                                        console.log("res", res);
                                        if (res === null || res === void 0 ? void 0 : res.data) {
                                            setGalleryPath(function(prev) {
                                                return _to_consumable_array(prev).concat([
                                                    {
                                                        id: nanoid(),
                                                        vs_file_url: res.data[0].imgFilePath,
                                                        vs_file_name: file.name,
                                                        type: "create"
                                                    }
                                                ]);
                                            });
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = files[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        return [
                            5,
                            _ts_values(_loop())
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePreviewimage(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteDocument = function(removeId, item) {
        if (item.type == "update") {
            var del = {
                vs_file_id: item.vs_file_id
            };
            setGalleryDel(_to_consumable_array(galleryDel).concat([
                del
            ]));
        }
        setGalleryPath(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
    };
    var handleCheck = function(ele, checked) {
        if (checked) {
            setSelectedObjectives(function(prev) {
                return _to_consumable_array(prev).concat([
                    {
                        vs_objective_objid: ele.set_objective_id,
                        vs_objective_name: ele.set_objective_name
                    }
                ]);
            });
        } else {
            setSelectedObjectives(function(prev) {
                return prev.filter(function(item) {
                    return item.vs_objective_objid !== ele.set_objective_id;
                });
            });
        }
    };
    var schema = yup.object().shape({
        branchid: yup.string().required("กรุณาเลือกร้านค้า"),
        vs_visit_appointmentdate: yup.date().typeError("กรุณาระบุวันเวลานัดหมายให้ถูกต้อง").required("กรุณาระบุวันเวลานัดหมาย").test("appointment-range", function(value) {
            if (!value) return true;
            if (dataID && originalAppDate) {
                return value.getTime() >= originalAppDate.getTime() || this.createError({
                    message: "วันเวลานัดหมายต้องไม่ก่อนวันเวลานัดหมายเดิม"
                });
            }
            var minimumDate = new Date();
            minimumDate.setHours(minimumDate.getHours() - 2);
            minimumDate.setSeconds(0, 0);
            return value.getTime() >= minimumDate.getTime() || this.createError({
                message: "วันเวลานัดหมายเลือกย้อนหลังไม่ได้"
            });
        }),
        vs_visit_visitdate: yup.date().transform(function(value, originalValue) {
            var isEmptyDate = originalValue === "" || originalValue == null || originalValue === "Invalid date" || _instanceof(originalValue, Date) && Number.isNaN(originalValue.getTime());
            return isEmptyDate ? null : value;
        }).nullable().notRequired().typeError("กรุณาระบุวันเวลาเข้าพบให้ถูกต้อง").test("visit-after-appointment", "วันเวลาเข้าพบต้องไม่น้อยกว่าวันเวลานัดหมาย", function(value) {
            return !value || !appDate || value.getTime() >= appDate.getTime();
        }).test("visit-backdate", "วันเวลาเข้าพบต้องไม่ก่อนวันเวลาเข้าพบเดิม", function(value) {
            if (!value) return true;
            if (originalVisitDate) {
                return value.getTime() >= originalVisitDate.getTime();
            }
            var minimumDate = new Date();
            minimumDate.setHours(minimumDate.getHours() - 2);
            minimumDate.setSeconds(0, 0);
            return value.getTime() >= minimumDate.getTime();
        })
    });
    var disable = param.view == "view" ? true : false;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: !isMobile ? "pagezoom" : "px-2",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: !isMobile ? "breadcrumb fs-16 ps-0 mb-1" : "breadcrumb fs-14 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/shopvisit",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการใบเยี่ยมชมร้านค้า"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: dataID ? param.view == "view" ? "/shopvisit/manage/".concat(parseInt(dataID), "/view") : "/shopvisit/manage/".concat(parseInt(dataID)) : "/shopvisit/manage",
                                        className: "tc-7  text-decoration-none",
                                        children: dataID ? param.view == "view" ? "รายละเอียดใบเยี่ยมชม" : "แก้ไขใบเยี่ยมชม" : "สร้างใบเยี่ยมชม"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: !isMobile ? "fs-24 mb-2" : "fs-20 mb-2",
                        children: dataID ? param.view == "view" ? "รายละเอียดใบเยี่ยมชม" : "แก้ไขใบเยี่ยมชม" : "สร้างใบเยี่ยมชม"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                onSubmit: function(values) {
                    console.log("in onSubmit");
                    if (visitDate && galleryPath.length == 0) {
                        setModalAlert(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: true
                            });
                        });
                        return false;
                    } else if (dataID) {
                        var _optionSale_filter_;
                        var data = {
                            vs_visit_id: values.vs_visit_id,
                            vs_visit_shid: parseInt(values.branch_shid),
                            vs_visit_shbranchid: parseInt(values.branchid),
                            vs_visit_shopname: values.vs_visit_shopname,
                            vs_visit_branchname: values.branch_name,
                            vs_visit_contactname: values.sh_branch_contactname,
                            vs_visit_contactphone: values.sh_branch_contactphone,
                            vs_visit_contactwhatsapp: values.sh_branch_contactwhatsapp,
                            vs_visit_suptactname: values.sh_branch_suptactname,
                            vs_visit_suptactphone: values.sh_branch_suptactphone,
                            vs_visit_suptactwhatsapp: values.sh_branch_suptactwhatsapp,
                            vs_visit_saleid: adminInfo.userRoleId != 3 ? values.vs_visit_saleid ? values.vs_visit_saleid : null : adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userId,
                            vs_visit_salename: (adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userRoleId) !== 3 ? (values === null || values === void 0 ? void 0 : values.vs_visit_saleid) ? (_optionSale_filter_ = optionSale.filter(function(item) {
                                return item.value === (values === null || values === void 0 ? void 0 : values.vs_visit_saleid);
                            })[0]) === null || _optionSale_filter_ === void 0 ? void 0 : _optionSale_filter_.label : "" : adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userFullName,
                            vs_visit_appointmentdate: appDate ? moment(appDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null,
                            vs_visit_visitdate: visitDate ? moment(visitDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null,
                            vs_visit_results: values.vs_visit_results,
                            vs_visit_todonext: values.vs_visit_todonext,
                            VsObjective: selectedObjectives,
                            VsFile: galleryPath,
                            vs_visit_cancelremark: values.vs_visit_cancelremark,
                            vs_visit_status: values.vs_visit_status,
                            VsObjectiveDelete: objectiveDelete,
                            VsFileDelete: galleryDel,
                            vs_visit_supportid: (adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userRoleId) !== 5 ? values.vs_visit_supportid : adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userId
                        };
                        dispatch(updateVisit(data, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    } else {
                        var _optionSale_filter_1;
                        var data1 = {
                            vs_visit_shid: parseInt(values.branch_shid),
                            vs_visit_shbranchid: parseInt(values.branchid),
                            vs_visit_shopname: values.vs_visit_shopname,
                            vs_visit_branchname: values.branch_name,
                            vs_visit_contactname: values.sh_branch_contactname,
                            vs_visit_contactphone: values.sh_branch_contactphone,
                            vs_visit_contactwhatsapp: values.sh_branch_contactwhatsapp,
                            vs_visit_suptactname: values.sh_branch_suptactname,
                            vs_visit_suptactphone: values.sh_branch_suptactphone,
                            vs_visit_suptactwhatsapp: values.sh_branch_suptactwhatsapp,
                            vs_visit_saleid: adminInfo.userRoleId != 3 ? values.vs_visit_saleid ? values.vs_visit_saleid : null : adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userId,
                            vs_visit_salename: (adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userRoleId) !== 3 ? (values === null || values === void 0 ? void 0 : values.vs_visit_saleid) ? (_optionSale_filter_1 = optionSale.filter(function(item) {
                                return item.value === (values === null || values === void 0 ? void 0 : values.vs_visit_saleid);
                            })[0]) === null || _optionSale_filter_1 === void 0 ? void 0 : _optionSale_filter_1.label : "" : adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userFullName,
                            vs_visit_appointmentdate: appDate ? moment(appDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null,
                            vs_visit_visitdate: visitDate ? moment(visitDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null,
                            vs_visit_results: values.vs_visit_results,
                            vs_visit_todonext: values.vs_visit_todonext,
                            vs_visit_status: 1,
                            VsObjective: selectedObjectives,
                            VsFile: galleryPath,
                            vs_visit_supportid: (adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userRoleId) !== 5 ? values.vs_visit_supportid : adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userId
                        };
                        dispatch(createVisit(data1, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    }
                },
                children: function(param1) {
                    var handleSubmit = param1.handleSubmit, handleChange = param1.handleChange, touched = param1.touched, errors = param1.errors, values = param1.values, setFieldValue = param1.setFieldValue, isInvalid = param1.isInvalid, isValid = param1.isValid, setValues = param1.setValues;
                    return /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(FocusFirstFormikError, {}),
                            /*#__PURE__*/ _jsxs(Form, {
                                noValidate: true,
                                onSubmit: function(e) {
                                    e.preventDefault();
                                    handleSubmit();
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("fieldset", {
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8 fs-18 fw-bold px-3",
                                                            children: "ข้อมูลร้านค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: !isMobile ? "pt-3 px-3" : "pt-3 px-0",
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "row gx-xl-4",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            "data-formik-field": "branchid",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    style: {
                                                                                        zIndex: 11
                                                                                    },
                                                                                    children: "ชื่อร้านค้า"
                                                                                }),
                                                                                dataID ? /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "vs_visit_shopname",
                                                                                    className: "form-control",
                                                                                    placeholder: "ชื่อร้านค้า",
                                                                                    value: values.vs_visit_shopname,
                                                                                    onChange: function(e) {
                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                            vs_visit_shopname: e.target.value
                                                                                        }));
                                                                                    },
                                                                                    disabled: true
                                                                                }) : /*#__PURE__*/ _jsx(ReactSearchAutocomplete, {
                                                                                    items: autoShop,
                                                                                    placeholder: "ชื่อร้านค้า",
                                                                                    onSelect: function(item) {
                                                                                        setFieldValue("branchid", item.sh_branch_id);
                                                                                        setFieldValue("vs_visit_shopname", item.nameShop); // 👈 เซ็ตตรงนี้
                                                                                        setFieldValue("branch_shid", item.sh_branch_shid);
                                                                                        setFieldValue("branch_name", item.sh_branch_name);
                                                                                        setFieldValue("sh_branch_contactname", item.sh_branch_contactname);
                                                                                        setFieldValue("sh_branch_contactphone", item.sh_branch_contactphone);
                                                                                        setFieldValue("sh_branch_contactwhatsapp", item.sh_branch_contactwhatsapp);
                                                                                        setFieldValue("sh_branch_suptactname", item.sh_branch_suptactname);
                                                                                        setFieldValue("sh_branch_suptactphone", item.sh_branch_suptactphone);
                                                                                        setFieldValue("sh_branch_suptactwhatsapp", item.sh_branch_suptactwhatsapp);
                                                                                        setFieldValue("vs_visit_saleid", item.sh_branch_intendant);
                                                                                        setFieldValue("sh_branch_ggmaplat", item.sh_branch_ggmaplat);
                                                                                        setFieldValue("sh_branch_ggmaplink", item.sh_branch_ggmaplink);
                                                                                        setFieldValue("sh_branch_ggmaplong", item.sh_branch_ggmaplong);
                                                                                    },
                                                                                    onClear: function() {
                                                                                        setFieldValue("branchid", "");
                                                                                        setFieldValue("vs_visit_shopname", "");
                                                                                        setFieldValue("branch_shid", "");
                                                                                        setFieldValue("branch_name", "");
                                                                                        setFieldValue("sh_branch_contactname", "");
                                                                                        setFieldValue("sh_branch_contactphone", "");
                                                                                        setFieldValue("sh_branch_contactwhatsapp", "");
                                                                                        setFieldValue("sh_branch_suptactname", "");
                                                                                        setFieldValue("sh_branch_suptactphone", "");
                                                                                        setFieldValue("sh_branch_suptactwhatsapp", "");
                                                                                        setFieldValue("vs_visit_saleid", "");
                                                                                        setFieldValue("sh_branch_ggmaplat", "");
                                                                                        setFieldValue("sh_branch_ggmaplink", "");
                                                                                        setFieldValue("sh_branch_ggmaplong", "");
                                                                                    },
                                                                                    autoFocus: true,
                                                                                    maxResults: 1000,
                                                                                    formatResult: formatResult,
                                                                                    fuseOptions: {
                                                                                        keys: [
                                                                                            "nameShop"
                                                                                        ]
                                                                                    },
                                                                                    resultStringKeyName: "nameShop",
                                                                                    styling: {
                                                                                        height: "50px",
                                                                                        borderRadius: "10px",
                                                                                        boxShadow: "none",
                                                                                        zIndex: 10,
                                                                                        border: !values.branchid ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                                                                                    },
                                                                                    showIcon: false,
                                                                                    className: "scrollSearchAutocomplete",
                                                                                    readOnly: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "สาขา"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "branch_name",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอกสาขา",
                                                                                    value: values.branch_name,
                                                                                    onChange: function(e) {
                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                            branch_name: e.target.value
                                                                                        }));
                                                                                    },
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-4 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ชื่อผู้ติดต่อ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "sh_branch_contactname",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอกชื่อผู้ติดต่อ",
                                                                                    value: values.sh_branch_contactname,
                                                                                    onChange: function(e) {
                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                            sh_branch_contactname: e.target.value
                                                                                        }));
                                                                                    },
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-4 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "เบอร์ผู้ติดต่อ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "sh_branch_contactphone",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอกเบอร์ผู้ติดต่อ",
                                                                                    value: values.sh_branch_contactphone,
                                                                                    onChange: function(e) {
                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                            sh_branch_contactphone: e.target.value
                                                                                        }));
                                                                                    },
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-4 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "What App ผู้ติดต่อ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "sh_branch_contactwhatsapp",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอก WhatApp ผู้ติดต่อ",
                                                                                    value: values.sh_branch_contactwhatsapp,
                                                                                    onChange: function(e) {
                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                            sh_branch_contactwhatsapp: e.target.value
                                                                                        }));
                                                                                    },
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-4 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "Google Map link"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "sh_branch_ggmaplink",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอก Google Map link",
                                                                                    value: values.sh_branch_ggmaplink,
                                                                                    disabled: true,
                                                                                    onChange: function(e) {
                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                            sh_branch_ggmaplink: e.target.value
                                                                                        }));
                                                                                    }
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-4 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "Lat"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "sh_branch_ggmaplat",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอก Lat",
                                                                                    value: values.sh_branch_ggmaplat,
                                                                                    disabled: true,
                                                                                    onChange: function(e) {
                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                            sh_branch_ggmaplat: e.target.value
                                                                                        }));
                                                                                    }
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-4 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "Long"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "sh_branch_ggmaplong",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอก Long",
                                                                                    value: values.sh_branch_ggmaplong,
                                                                                    disabled: true,
                                                                                    onChange: function(e) {
                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                            sh_branch_ggmaplong: e.target.value
                                                                                        }));
                                                                                    }
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-4 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "วัน - เวลาที่นัดหมาย",
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-danger ms-1",
                                                                                            children: " *"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "pr-[15px]",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                                                            name: "vs_visit_appointmentdate",
                                                                                            selected: appDate,
                                                                                            onChange: function(date) {
                                                                                                setAppDate(date);
                                                                                                setFieldValue("vs_visit_appointmentdate", date);
                                                                                                if (date && visitDate && visitDate.getTime() < date.getTime()) {
                                                                                                    setVisitDate("");
                                                                                                    setFieldValue("vs_visit_visitdate", null);
                                                                                                }
                                                                                            },
                                                                                            showTimeSelect: true,
                                                                                            disabled: values.vs_visit_status == 3 || values.vs_visit_status == 2 ? true : disable,
                                                                                            timeFormat: "HH:mm",
                                                                                            timeIntervals: 10,
                                                                                            dateFormat: "dd/MM/yyyy HH:mm",
                                                                                            minDate: appointmentBoundaryDate || undefined,
                                                                                            filterTime: canSelectAppointmentTime,
                                                                                            placeholderText: "วัน - เวลาที่นัดหมาย",
                                                                                            className: "w-100 h-[44px] datepicker2 ".concat(touched.vs_visit_appointmentdate && errors.vs_visit_appointmentdate ? "is-invalid" : "")
                                                                                        }),
                                                                                        touched.vs_visit_appointmentdate && errors.vs_visit_appointmentdate && /*#__PURE__*/ _jsx("div", {
                                                                                            className: "invalid-feedback d-block",
                                                                                            children: errors.vs_visit_appointmentdate
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-4 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 p-0",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "เซลล์ที่ดูแล"
                                                                                }),
                                                                                adminInfo.userRoleId != 3 ? /*#__PURE__*/ _jsx(Select, {
                                                                                    as: "select",
                                                                                    name: "vs_visit_saleid",
                                                                                    onChange: function(e) {
                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                            vs_visit_saleid: e.value
                                                                                        }));
                                                                                    },
                                                                                    className: "w-100 select-st-1",
                                                                                    options: optionSale,
                                                                                    placeholder: "เลือกเซลล์ที่ดูแล",
                                                                                    value: optionSale.filter(function(item) {
                                                                                        return item.value === values.vs_visit_saleid;
                                                                                    }),
                                                                                    disabled: values.vs_visit_status == 3 || values.vs_visit_status == 2 ? true : disable
                                                                                }) : /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "vs_visit_saleid",
                                                                                    className: "form-control",
                                                                                    placeholder: "ผู้ดูแล",
                                                                                    value: (adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userFullName) || "",
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-4 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 p-0",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "เซลล์ซัพพอร์ต"
                                                                                }),
                                                                                adminInfo.userRoleId != 5 ? /*#__PURE__*/ _jsx(Select, {
                                                                                    as: "select",
                                                                                    name: "vs_visit_supportid",
                                                                                    onChange: function(e) {
                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                            vs_visit_supportid: e.value
                                                                                        }));
                                                                                    },
                                                                                    className: "w-100 select-st-1",
                                                                                    options: salesSupport,
                                                                                    placeholder: "เลือกเซลล์ซัพพอร์ต",
                                                                                    value: salesSupport.filter(function(item) {
                                                                                        return item.value === values.vs_visit_supportid;
                                                                                    })
                                                                                }) : /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    className: "form-st-3 py-2",
                                                                                    placeholder: "ค้นหาเซลล์ซัพพอร์ต",
                                                                                    value: adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userFullName,
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-4 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "วัน - เวลาที่เข้าพบ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "pr-[15px]",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                                                            name: "vs_visit_visitdate",
                                                                                            selected: visitDate,
                                                                                            placeholderText: "วัน - เวลาที่เข้าพบ",
                                                                                            onChange: function(date) {
                                                                                                setVisitDate(date || "");
                                                                                                setFieldValue("vs_visit_visitdate", date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : null);
                                                                                            },
                                                                                            showTimeSelect: true,
                                                                                            timeFormat: "HH:mm",
                                                                                            timeIntervals: 10,
                                                                                            dateFormat: "dd/MM/yyyy HH:mm",
                                                                                            minDate: visitBoundaryDate || undefined,
                                                                                            filterTime: canSelectVisitTime,
                                                                                            placeholder: "DD/MM/YYYY HH:mm",
                                                                                            className: "w-100 h-[44px] datepicker2 ".concat(touched.vs_visit_visitdate && errors.vs_visit_visitdate ? "is-invalid" : ""),
                                                                                            // value={
                                                                                            //   values.vs_visit_visitdate
                                                                                            //     ? moment(values.vs_visit_visitdate).format(
                                                                                            //         "DD/MM/YYYY HH:mm"
                                                                                            //       )
                                                                                            //     : ""
                                                                                            // }
                                                                                            disabled: values.vs_visit_status == 3 || values.vs_visit_status == 2 ? true : disable
                                                                                        }),
                                                                                        touched.vs_visit_visitdate && errors.vs_visit_visitdate && /*#__PURE__*/ _jsx("div", {
                                                                                            className: "invalid-feedback d-block",
                                                                                            children: errors.vs_visit_visitdate
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-12 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ผลการเยี่ยมร้านค้า"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    as: "textarea",
                                                                                    rows: 3,
                                                                                    name: "vs_visit_results",
                                                                                    value: values.vs_visit_results,
                                                                                    onChange: function(e) {
                                                                                        setFieldValue("vs_visit_results", e.target.value);
                                                                                    },
                                                                                    disabled: values.vs_visit_status == 3 || values.vs_visit_status == 2 ? true : disable
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-12 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "สิ่งที่จะต้องดำเนินการต่อ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    as: "textarea",
                                                                                    rows: 3,
                                                                                    name: "vs_visit_todonext",
                                                                                    value: values.vs_visit_todonext,
                                                                                    onChange: function(e) {
                                                                                        setFieldValue("vs_visit_todonext", e.target.value);
                                                                                    },
                                                                                    disabled: values.vs_visit_status == 3 || values.vs_visit_status == 2 ? true : disable
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: !isMobile ? "pt-2" : "px-2",
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "row gx-xl-4",
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-12 col-md-12",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "card card-st-3 mb-3",
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "card-body px-xl-3",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-2 tc-10",
                                                                        children: "วัตถุประสงค์"
                                                                    }),
                                                                    dataObjective.map(function(ele, i) {
                                                                        var selected = selectedObjectives.find(function(obj) {
                                                                            return obj.vs_objective_objid === ele.set_objective_id;
                                                                        });
                                                                        return /*#__PURE__*/ _jsxs(Stack, {
                                                                            direction: "row",
                                                                            justifyContent: "flex-start",
                                                                            className: "mt-2",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Check, {
                                                                                    inline: true,
                                                                                    type: "checkbox",
                                                                                    id: "p-checkbox-".concat(i),
                                                                                    label: ele.set_objective_id === 1 ? "อื่นๆ ระบุ" : ele.set_objective_name,
                                                                                    className: "form-check-st-2 tc-7 w-[250px]",
                                                                                    checked: !!selected,
                                                                                    disabled: values.vs_visit_status == 3 || values.vs_visit_status == 2 ? true : disable,
                                                                                    onChange: function(e) {
                                                                                        return handleCheck(ele, e.target.checked);
                                                                                    }
                                                                                }),
                                                                                ele.set_objective_id === 1 && !!selected && /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอกวัตถุประสงค์อื่น ๆ",
                                                                                    disabled: values.vs_visit_status == 3 || values.vs_visit_status == 2 ? true : disable,
                                                                                    value: selected.vs_objective_name || "",
                                                                                    onChange: function(e) {
                                                                                        // อัปเดตชื่อเฉพาะ objective id = 1
                                                                                        setSelectedObjectives(function(prev) {
                                                                                            return prev.map(function(obj) {
                                                                                                return obj.vs_objective_objid === 1 ? _object_spread_props(_object_spread({}, obj), {
                                                                                                    vs_objective_name: e.target.value
                                                                                                }) : obj;
                                                                                            });
                                                                                        });
                                                                                    }
                                                                                })
                                                                            ]
                                                                        }, "p-checkbox".concat(i));
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mt-2 mb-3",
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "card-body px-xl-3",
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: !isMobile ? "pt-2" : "px-2",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "row gx-xl-4",
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-xl-12 col-md-12",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-2 mt-2 tc-10",
                                                                        children: "รูปภาพหน้าร้าน"
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        className: "row gx-xl-4 mt-3 ml-1",
                                                                        children: [
                                                                            galleryPath.map(function(item, index) {
                                                                                return /*#__PURE__*/ _jsx("div", {
                                                                                    className: "col-xl-2 col-md-3 mb-3",
                                                                                    children: /*#__PURE__*/ _jsxs(Stack, {
                                                                                        direction: "row",
                                                                                        justifyContent: "space-between",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx("img", {
                                                                                                src: item.vs_file_url,
                                                                                                style: {
                                                                                                    width: 150,
                                                                                                    height: 150
                                                                                                }
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx("button", {
                                                                                                type: "button",
                                                                                                className: "btn  btn-delete-file-cross mr-3",
                                                                                                disabled: values.vs_visit_status == 3 || values.vs_visit_status == 2 ? true : disable,
                                                                                                onClick: function() {
                                                                                                    return deleteDocument(item.id, item);
                                                                                                }
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }, index);
                                                                            }),
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "col-xl-2 col-md-3 border-dashed-1 w-[150px] h-[150px]",
                                                                                onClick: function(e) {
                                                                                    return document.getElementById("fileGalleryUpload").click();
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("input", {
                                                                                        type: "file",
                                                                                        multiple: true,
                                                                                        className: "fileUpload hide-input",
                                                                                        id: "fileGalleryUpload",
                                                                                        accept: ".png, .jpg",
                                                                                        disabled: values.vs_visit_status == 3 || values.vs_visit_status == 2 ? true : disable,
                                                                                        onChange: handlePreviewimage
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs("center", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(AddPhotoAlternateIcon, {
                                                                                                style: {
                                                                                                    fontSize: 50,
                                                                                                    color: "#B00412",
                                                                                                    marginTop: 15
                                                                                                }
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                                className: "fs-12",
                                                                                                style: {
                                                                                                    color: "#B00412"
                                                                                                },
                                                                                                children: "เพิ่มรูปภาพ"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card card-st-3 mb-4",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "card-body px-xl-3 d-flex ",
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "button",
                                                    onClick: function(e) {
                                                        navigate(-1);
                                                    },
                                                    className: "btn-st-6 me-3 btn ms-auto",
                                                    children: "ยกเลิก"
                                                }),
                                                param.view !== "view" && values.vs_visit_status !== 2 && values.vs_visit_status !== 3 && /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    className: "btn-st-3 me-3",
                                                    children: "บันทึก"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(ModalAllder, {
                                modal: modalAlert,
                                setModal: setModalAlert,
                                htitle: "แจ้งเตือน",
                                hbtn: false,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "text-center pt-4 tc-5",
                                        style: {
                                            fontSize: "24px"
                                        },
                                        children: /*#__PURE__*/ _jsx("div", {
                                            children: galleryPath.length == 0 && "- กรุณาเพิ่มรูปภาพ"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "d-flex align-items-center pb-4 pt-5 ",
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            className: "btn-st-3 mx-auto",
                                            onClick: function() {
                                                return setModalAlert(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        open: false
                                                    });
                                                });
                                            },
                                            children: "ยืนยัน"
                                        })
                                    })
                                ]
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate,
                direction: "/shopvisit"
            })
        ]
    });
}
export function StatusModal(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID, shopId = param.shopId, isMobile = param.isMobile, filterPayload = param.filterPayload;
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(1), 2), type = _useState[0], setType = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), id = _useState1[0], setId = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), text = _useState2[0], setText = _useState2[1];
    var optionStatus = [
        {
            value: 1,
            label: "นัดหมาย"
        },
        {
            value: 2,
            label: "เยี่ยมชมแล้ว"
        },
        {
            value: 3,
            label: "ยกเลิก"
        },
        {
            value: 4,
            label: "เลื่อนวันนัด"
        }
    ];
    var updateStatusVisitReducer = useAppSelector(function(state) {
        return state.updateStatusVisitReducer;
    });
    useEffect(function() {
        if (modal.data == null) {
            setType(1);
            setId(0);
            setText("");
        }
        if (modal.data != null) {
            var vul = modal.data;
            setType(vul.status);
            setId(vul.id);
            setText(vul.text);
        }
    }, [
        modal.data,
        modal.open
    ]);
    useEffect(function() {
        setIsLoading(updateStatusVisitReducer.isFetching);
        if (updateStatusVisitReducer.data && !updateStatusVisitReducer.isError) {
            setTextsuccess("เปลี่ยนสถานะใบเยี่ยมชมร้านค้าสำเร็จ");
            setModalsuccess(true);
            dispatch(clearupdateStatusVisit());
            dispatch(getDataVisit(filterPayload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(getDataVisitTotal(filterPayload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setType(1);
            setId(0);
            setText("");
        }
    }, [
        updateStatusVisitReducer
    ]);
    var onClickModel = function() {
        if (modal.typeData == "visitStatus") {
            var data = {
                visitid: parseInt(id),
                visitstatus: parseInt(type),
                remark: text
            };
            dispatch(updateStatusVisit(data, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: !isMobile ? "px-3" : "px-1",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: !isMobile ? "text-center fs-22 tc-5 my-4" : "fs-18 tc-5 text-center",
                    children: [
                        "คุณต้องการเปลี่ยนสถานะ",
                        !isMobile ? "ใบเยี่ยมชมร้านค้านี้" : /*#__PURE__*/ _jsx("p", {
                            children: "ใบเยี่ยมชมร้านค้านี้"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center my-6",
                    children: /*#__PURE__*/ _jsx(Form.Group, {
                        className: "mb-2 form-st-3 p-0",
                        children: /*#__PURE__*/ _jsx(Select, {
                            as: "select",
                            className: "w-100 select-st-1",
                            placeholder: "สถานะ",
                            // options={optionStatus}
                            options: optionStatus.filter(function(v) {
                                return type == 2 && v.value == 3 || type == 1 && v.value > 0;
                            }),
                            value: optionStatus.find(function(opt) {
                                return opt.value === type;
                            }) || null,
                            onChange: function(e) {
                                setType(e ? e.value : "");
                            }
                        })
                    })
                }),
                type == 3 && /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsx(Form.Label, {
                                className: "mb-1",
                                children: "เหตุผล"
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                as: "textarea",
                                rows: 3,
                                name: "pd_product_detail",
                                value: text,
                                onChange: function(e) {
                                    setText(e.target.value);
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-3",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
